import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRights, useStore } from 'hooks';
import { useTour } from '../use-tour';
import { toast } from 'components/ui';
import { TOUR_REGISTRY } from '../tour.registry';

export const useAiCreateRequestTour = () => {
  const navigate = useNavigate();
  const { startTour, persistence } = useTour();
  const { onboardings, user } = useStore();

  const requestsListRights = useRights('request_log_list');

  useEffect(() => {
    if (
      persistence.hasSeen('ai_request', user.id) ||
      !requestsListRights.create
    ) {
      return;
    }

    const tour = TOUR_REGISTRY['ai_request'];

    const id = toast({
      title: 'Заявки можно создавать с помощью ИИ',
      description:
        'Мы добавили новые способы оформления заявок с участием искусственного интеллекта. Это поможет Вам экономить время и не отвлекаться от звонков.',
      actions: {
        acceptLabel: 'Показать, как это работает',
        cancelLabel: 'Пропустить',
        onAccept: () => {
          navigate('../create');
          startTour('ai_request');
        },
        onCancel: () =>
          onboardings.patchOnboardingInfo(
            {
              block: 'ai_request',
              viewed: true,
              version: tour.version,
            },
            user.id
          ),
      },
    });

    return () => {
      toast.dismiss(id);
    };
  }, []);
};
